import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/service/user.service';
import { NavigationEnd, Router } from '@angular/router';
import { ROUTES } from 'src/app/route/routes';
import { LocaleService } from 'src/app/service/locale.service';
import { SessionStorageService } from 'src/app/service/session-storage.service';
import { NO_LOGO } from 'src/app/constants/storage-elements';
import { LocationStrategy } from '@angular/common';
import { LANGUAGES } from '../../constants/lang';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit {
  public route!: string;

  public name: string;

  public no_logo: boolean = false;
  public langs = Object.keys(LANGUAGES);
  public previousUrl: string = '';
  constructor(
    private router: Router,
    public userService: UserService,
    private local: LocaleService,
    private sStorager: SessionStorageService,
    private location: LocationStrategy
  ) {
    this.langs.shift();
    this.name = this.userService.inizialiNome!;
    this.no_logo =
      !!this.sStorager.getElement(NO_LOGO) &&
      this.sStorager.getElement(NO_LOGO) === 'NO_LOGO';

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.route;
        this.route = event.url;
        console.log(this.previousUrl, this.route);
      }
    });
  }

  ngOnInit(): void {}

  changeLang(val: string) {
    this.local.changeLanguage(val);
  }

  logout() {
    this.userService.logout();
  }

  termina() {
    window.opener.focus();
    window.close();
  }

  hasBackButton() {
    return (
      this.route !== '/' &&
      this.route !== ROUTES.PRE_LANDING.absolute_path &&
      this.route !== ROUTES.LOGIN.absolute_path &&
      this.route !== ROUTES.MESSAGE.absolute_path &&
      !this.route.endsWith(ROUTES.HOME.absolute_path) &&
      !this.route.endsWith(ROUTES.EVENT_DELETE.absolute_path) &&
      !this.route.endsWith(ROUTES.EVENT_CONFIRMATION.absolute_path)
    );
  }

  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate([ROUTES.HOME.path]);
        break;
      }
    }
  }

  goBack(): void {
    const currentUrl = this.router.url;
    if (currentUrl === '/tender/eventi') {
      this.router.navigate(['/tender/home']);
    } else if (currentUrl === '/spa/eventi') {
      this.router.navigate(['/spa/home']);
    } else if (currentUrl === '/tender/prenotazioni') {
      this.router.navigate(['/tender/home']);
    } else if (currentUrl === '/spa/prenotazioni') {
      this.router.navigate(['/spa/home']);
    } else if (currentUrl === '/tender/eventi/calendario') {
      if (this.previousUrl === '/tender/prenotazioni') {
        this.router.navigate(['/tender/prenotazioni']);
      } else {
        this.router.navigate(['/tender/eventi']);
      }
    } else if (currentUrl === '/spa/eventi/calendario') {
      if (this.previousUrl === '/spa/prenotazioni') {
        this.router.navigate(['/spa/prenotazioni']);
      } else {
        this.router.navigate(['/spa/eventi']);
      }
    } else {
      this.location.back();
    }
  }
}
